import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaArrowRight, FaEnvelope, FaLock, FaUserShield } from 'react-icons/fa';
import { useAuth } from '../context/AuthContext';
import logo from '../assets/logo.png';
import './AuthPages.css';

function AdminRegisterPage() {
  const { registerTeacher } = useAuth();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    email: '',
    password: '',
    confirmPassword: ''
  });
  const [errors, setErrors] = useState({});
  const [serverError, setServerError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: '' }));
    }
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    setServerError('');
    setErrors({});

    if (formData.password !== formData.confirmPassword) {
      setErrors({ confirmPassword: 'Passwords do not match' });
      return;
    }

    setLoading(true);
    try {
      const data = await registerTeacher(formData.email, formData.password, formData.confirmPassword);
      setTimeout(() => {
        navigate('/admin/login?approval=pending', {
          state: {
            pendingMessage: data?.message || 'Admin registration submitted for approval.'
          }
        });
      }, 800);
    } catch (err) {
      setServerError(err.message || 'Admin registration failed.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-shell admin-auth-wrapper">
      <div className="blur-circle circle-1" />
      <div className="blur-circle circle-2" />

      <motion.div
        className="auth-card register-card"
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.55 }}
      >
        <div className="register-header">
          <img src={logo} alt="Epsilon logo" className="auth-brand-logo large" />
          <div>
            <p className="register-kicker">Hidden Access</p>
            <h2>Admin Registration</h2>
            <p>Create an admin account directly from the private registration URL.</p>
          </div>
        </div>

        <div className="role-selector">
          <button type="button" className="btn-active" disabled>
            <FaUserShield /> Admin
          </button>
        </div>

        {serverError && <div className="error-toast">{serverError}</div>}

        <form onSubmit={handleRegister} className="auth-form modern-form">
          <div className="input-container">
            <label><FaEnvelope /> Email Address</label>
            <input type="email" name="email" value={formData.email} onChange={handleChange} required />
          </div>

          <div className="input-container">
            <label><FaLock /> Password</label>
            <input type="password" name="password" value={formData.password} onChange={handleChange} required />
          </div>

          <div className="input-container">
            <label><FaLock /> Confirm Password</label>
            <input
              type="password"
              name="confirmPassword"
              value={formData.confirmPassword}
              onChange={handleChange}
              required
            />
            {errors.confirmPassword && <small className="error-text">{errors.confirmPassword}</small>}
          </div>

          <button type="submit" className="btn-admin-login" disabled={loading}>
            {loading ? 'Processing...' : <>Create Admin <FaArrowRight /></>}
          </button>
        </form>

        <div className="auth-footer auth-footer-links">
          <p>Already approved? <Link to="/admin/login" className="link">Admin Login</Link></p>
          <p style={{ marginTop: '6px' }}>Looking for Student Registration? <Link to="/register" className="link">Register as Student</Link></p>
        </div>
      </motion.div>
    </div>
  );
}

export default AdminRegisterPage;
